import { render, staticRenderFns } from "./inspectionReportStemp.vue?vue&type=template&id=1954ac73&scoped=true&"
import script from "./inspectionReportStemp.vue?vue&type=script&lang=js&"
export * from "./inspectionReportStemp.vue?vue&type=script&lang=js&"
import style0 from "./inspectionReportStemp.vue?vue&type=style&index=0&id=1954ac73&lang=sass&scoped=true&"
import style1 from "./inspectionReportStemp.vue?vue&type=style&index=1&id=1954ac73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954ac73",
  null
  
)

export default component.exports